module.exports = __webpack_public_path__ + "static/media/stepper-collect-active.2d21d48a.svg";